import React, { Component } from 'react';
/* eslint-disable */
import axios from 'axios';
import { MY_API_URL } from '../../Apanel/QueryMe';
import Switch from 'react-switch';
import {
	Button,
	ButtonGroup,
	ButtonToolbar,
	Card,
	CardBody,
	Col,
	Badge,
	Table,
	Modal,
	Container,
	Row,
} from 'reactstrap';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import Alert from '../../../shared/components/Alert';
import ProfileImage from '../../Apanel/ProfileImage';
const apiurl = MY_API_URL;
const dimgurl = apiurl + 'ava.png';
import TotalProfit from '../../AdminPanel/ecomponents/TotalProfit';
const initialstate = {
	image: dimgurl,
	allusers: [],
	showAlert: false,
	alertType: '',
	alertText: '',
	newrole: 'recruiter',
	emails: '',
	domain: '',
	token: localStorage.token,
	content_add: '',
	myItems: [],
	testEmails: [],
	currentcolor: [
		'#531CB3',
		'#7149EE',
		'#B754FF',
		'#ED4FEF',
		'#ED49AB',
		'#ED4FEF',
		'#B754FF',
		'#7149EE',
	],
	comprec: [{ name: 'Page A', amt: '0' }],
};
class Dashboard extends Component {
	constructor(props) {
		super(props);
	}
	state = { ...initialstate };
	componentDidMount() {
		localStorage.setItem('viewrecruiter', '');
		localStorage.setItem('gotodash', 0);
		if (localStorage.profile_completed === '0') {
			localStorage.setItem('came_from', 'dashboard');
			this.props.history.push({
				pathname: '/profile',
				backTo: '/',
			});
		} else {
			this.handleGetUsers(localStorage.token);
			this.handleFocus = this.handleFocus.bind(this);
			this.handleChange = this.handleChange.bind(this);

			this.handleClick = this.handleClick.bind(this);
			this.lastId = -1;
		}
	}
	// handleChange = (event) => {
	// 	const { name, value } = event.target;
	// 	console.log(name + ' ' + value);
	// 	this.setState({ [name]: value });
	// };

	handleFocus(event) {
		this.setState({ content_add: '' });
	}

	handleChange = (event) => {
		const { name, value } = event.target;
		console.log(name + ' ' + value);
		this.setState({ [name]: value });
		const usr_input = event.target.value;
		console.log(usr_input);
		this.setState({ content_add: usr_input });
	};
	handleAddEmail = async (event) => {
		event.preventDefault();
		var mainemail = localStorage.by;
		var mainemail_string_array = mainemail.split('@');
		var domain_string_location = mainemail_string_array.length - 1;
		var mainemaildomain = mainemail_string_array[domain_string_location];

		var validemails = [];
		var rawemails = this.state.content_add.trim();
		var aallemails = rawemails
			.split('\n')
			.join(',')
			.split(' ')
			.join(',')
			.split(',');
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		// console.log(validemails);
		var newArray = this.state.myItems;
		var testEmails = this.state.testEmails;
		console.log(this.state.allones);
		await Promise.all(
			aallemails.map((aallemail, index) => {
				return new Promise((resolve, reject) => {
					let isvalidrec = re.test(aallemail);
					if (isvalidrec) {
						var newemail_string_array = aallemail.split('@');
						var domain_string_location = newemail_string_array.length - 1;
						var newemaildomain = newemail_string_array[domain_string_location];
						if (mainemaildomain == newemaildomain) {
							var njk = this.state.allones.includes(aallemail);
							var dnjk = this.state.testEmails.includes(aallemail);
							if (njk) {
								resolve('');
							} else {
								if (dnjk) {
									resolve('');
								} else {
									newArray.push({
										content: aallemail,
										id: ++this.lastId,
									});
									testEmails.push(aallemail);
									this.setState(
										{
											myItems: newArray,
											content_add: '',
										},
										() => {
											console.log(this.state.myItems);
											resolve('');
										},
									);
								}
							}
						} else {
							resolve('');
						}
					} else {
						resolve('');
					}
				});
			}),
		);
		this.setState({
			content_add: '',
		});
	};

	handleClick(event) {
		const idToRemove = Number(event.target.dataset['item']);
		const emailToRemove = event.target.dataset['email'];
		const newArray = this.state.myItems.filter((listitem) => {
			return listitem.id !== idToRemove;
		});
		const testEmails = this.state.testEmails.filter((elistitem) => {
			return elistitem !== emailToRemove;
		});
		this.setState({ myItems: newArray, testEmails: testEmails }, () => {
			console.log('items ', this.state.myItems);
			console.log('emails ', this.state.testEmails);
		});
	}
	makeAddedList() {
		const elements = this.state.myItems.map((listitem, index) => (
			<span
				className="emaillist"
				key={listitem.id}
				onClick={this.handleClick}
				data-item={listitem.id}
				data-email={listitem.content}
				style={{
					backgroundColor: this.state.currentcolor[
						index % this.state.currentcolor.length
					],
					width: 'auto',
				}}
			>
				{listitem.content}
			</span>
		));
		return elements;
	}

	handleAccess = (recemail, e) => {
		localStorage.setItem('viewrecruiter', recemail);
		// this.props.history.push({
		// 	pathname: '/recruiter/dashboard',
		// 	recemail: recemail,
		// });
		location.assign('/recruiter/dashboard');
		// const win = window.open('/recruiter/dashboard');
		// if (win != null) {
		// 	win.focus();
		// }
	};
	handleAkey = () => {
		this.setState({
			addUserModal: true,
		});
	};
	handleUserSubmit = (event) => {
		event.preventDefault();

		var jjjjjjjj = this.state.testEmails;
		if (jjjjjjjj.length >= 1) {
			const headers = {
				'Content-Type': 'application/json',
				Authorization: localStorage.token,
			};

			const addkeyurl = apiurl + 'addcomprecs';
			var postData = {
				emails: this.state.testEmails,
				cemail: localStorage.by,
				cname: localStorage.name,
			};
			axios
				.post(addkeyurl, postData, {
					headers: headers,
				})
				.then((response) => {
					if (response.data.error) {
						this.setState({
							showAlert: true,
							alertType: 'warning',
							alertText: response.data.message,
						});
					} else {
						var okemailss = response.data.data[0];
						okemailss.toString();
						this.setState(
							{
								addUserModal: false,
								showAlert: false,
								emails: '',
								myItems: [],
								testEmails: [],
							},
							() => {
								swal(okemailss + ' Recruiters ' + response.data.message, {
									icon: 'success',
								});
								this.handleGetUsers(localStorage.token);
							},
						);
					}
				})
				.catch((error) => {
					console.log('Error is ', error);
					this.setState({
						alertType: 'danger',
						showAlert: true,
						alertText: 'Failed Try Again Later!',
					});
				});
		} else {
			this.setState({
				showAlert: true,
				alertType: 'warning',
				alertText: 'Enter Valid Email ID',
			});
		}
	};
	handleCkey = () => {
		this.setState({
			addUserModal: false,
		});
	};
	handleTkey = (id, keyword, checked) => {
		// console.log(checked + 'checked');
		// console.log(id + 'id');
		// console.log(keyword + 'keyword');
		var keysts = checked == true ? 0 : 1;
		var kstatus = 'Block';
		if (checked) {
			kstatus = 'Unblock';
		}
		swal({
			title: kstatus + ' ' + keyword,
			text: 'Are you sure?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then((keyconfirm) => {
			if (keyconfirm) {
				const headers = {
					'Content-Type': 'application/json',
					Authorization: localStorage.token,
				};

				const togkeyurl = apiurl + 'toguser';
				var postData = {
					userid: id,
					ustatus: keysts,
				};
				axios
					.post(togkeyurl, postData, {
						headers: headers,
					})
					.then((response) => {
						console.log(response.data.message);

						if (response.data.error) {
							swal(keyword + ' ' + response.data.message, {
								icon: 'warning',
							});
						} else {
							this.handleGetUsers(localStorage.token);
							swal(keyword + ' ' + response.data.message, {
								icon: 'success',
							});
						}
					})
					.catch((error) => {
						console.log('Error is ', error);
						swal('Try Again Later', {
							icon: 'Danger',
						});
					});
			}
		});
	};
	handleGetUsers = (token) => {
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			role: 'recruiter',
			cemail: localStorage.by,
		};
		const getuurl = apiurl + 'comptexperts';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				if (response.data.error) {
				} else {
					let hk = [localStorage.by];
					let gk = [...response.data.data];
					gk.map((rk, index) => {
						hk.push(rk.email);
					});
					this.setState({
						allusers: [...response.data.data],
						allones: hk,
					});
				}
			})
			.catch((error) => {
				localStorage.clear();
				this.props.history.push('/');
			});
	};
	handleGetTendays = (token) => {
		let tenthday = moment().subtract(9, 'days').format('YYYY-MM-DD');
		let ninethday = moment().subtract(8, 'days').format('YYYY-MM-DD');
		let eightthday = moment().subtract(7, 'days').format('YYYY-MM-DD');
		let seventhday = moment().subtract(6, 'days').format('YYYY-MM-DD');
		let sixthday = moment().subtract(5, 'days').format('YYYY-MM-DD');
		let fivethday = moment().subtract(4, 'days').format('YYYY-MM-DD');
		let fourthday = moment().subtract(3, 'days').format('YYYY-MM-DD');
		let threethday = moment().subtract(2, 'days').format('YYYY-MM-DD');
		let twothday = moment().subtract(1, 'days').format('YYYY-MM-DD');
		let today = moment().format('YYYY-MM-DD');
		let tendays = [
			today,
			twothday,
			threethday,
			fourthday,
			fivethday,
			sixthday,
			seventhday,
			eightthday,
			ninethday,
			tenthday,
		];
		const headers = {
			'Content-Type': 'application/json',
			Authorization: localStorage.token,
		};
		var postData = {
			token: token,
			tendays: tendays,
			cemail: localStorage.by,
		};
		const getuurl = apiurl + 'comptendaysdash';
		axios
			.post(getuurl, postData, {
				headers: headers,
			})
			.then((response) => {
				console.log('comptendays: ', response.data);
				if (response.data.error) {
				} else {
					this.setState({
						comprec: response.data.comprec,
					});
				}
			})
			.catch((error) => {
				localStorage.clear();
				this.props.history.push('/');
			});
	};
	render() {
		const {
			email,
			addUserModal,
			showObox,
			showCbox,
			showRbox,
			showAlert,
			alertType,
			alertText,
			newrole,
			domain,
			comprec,
			allusers,
		} = this.state;
		return (
			<Container className="dashboard">
				<Row>
					<TotalProfit
						tname="Company Recruiters"
						totaln={allusers.length}
						rdata={comprec}
					/>
				</Row>
				<Col md={12}>
					<Card>
						<CardBody>
							<div className="card__title">
								<h5 className="bold-text">
									All Recruiters
									<Button
										className="float-right btn-sm"
										color="success"
										onClick={this.handleAkey}
									>
										+
									</Button>
								</h5>
							</div>
							<Table responsive hover>
								<thead>
									<tr>
										<th>#</th>
										<th>.</th>
										<th>Manage</th>
										<th>Email</th>
										<th>Type</th>
										<th>Name</th>
										<th>Mobile</th>
										<th>Registered</th>
										<th>Access</th>
									</tr>
								</thead>
								<tbody>
									{this.state.allusers &&
										this.state.allusers.map((huser, index) => {
											if (huser.role === 'recruiter') {
												var usts = true;
												if (huser.blocked === 1) {
													usts = false;
												}
												return (
													<tr key={index}>
														<td>{index + 1}</td>
														<td>
															<ProfileImage
																clname="topbar__avatar-img"
																flpath={
																	huser.image_url
																		? huser.image_url
																		: this.state.image
																}
															/>
														</td>
														<td>
															<Switch
																onChange={this.handleTkey.bind(
																	this,
																	huser.id,
																	huser.email,
																)}
																checked={usts}
															/>
														</td>
														<td>{huser.email}</td>
														<td>
															<h4>
																<Badge color="success">{huser.role}</Badge>
															</h4>
														</td>
														<td>{huser.name}</td>
														<td>{huser.mobile}</td>
														<td>{huser.createdon}</td>
														<td>
															<button
																className="btn btn-sm btn-primary accessbtnrec"
																type="button"
																onClick={this.handleAccess.bind(
																	this,
																	huser.email,
																)}
															>
																Access
															</button>
														</td>
													</tr>
												);
											}
										})}
								</tbody>
							</Table>
							<Modal
								isOpen={this.state.addUserModal}
								modalClassName="ltr-support"
								className="modal-dialog--primary"
							>
								<div className="modal__header">
									<button
										className="lnr lnr-cross modal__close-btn"
										type="button"
										onClick={this.handleCkey}
									/>
									<h4 className="text-modal  modal__title">
										Add New Recruiter
									</h4>
								</div>
								<div className="modal__body">
									{this.state.showAlert ? (
										<Alert color={this.state.alertType}>
											<p>{this.state.alertText}</p>
										</Alert>
									) : null}
									<p>{this.makeAddedList()}</p>
									<form
										className="form"
										onSubmit={(event) => this.handleAddEmail(event)}
									>
										{this.state.showAlert ? (
											<Alert color={this.state.alertType}>
												<p>{this.state.alertText}</p>
											</Alert>
										) : null}
										<div className="form__form-group">
											{/* <span className="form__form-group-label">
													Add Email ID
												</span> */}
											<div className="form__form-group-field">
												<textarea
													name="remail"
													type="email"
													placeholder="Add Email ID"
													onFocus={this.handleFocus}
													onChange={this.handleChange}
													value={this.state.content_add}
													style={{ width: '300px' }}
													onKeyUp={(e) => {
														e.preventDefault();

														if (
															e.keyCode == 13 ||
															e.keyCode == 32 ||
															e.keyCode == 188
														) {
															this.handleAddEmail(event);
														}
													}}
												/>
												{/* <button className="btn btn-primary btn-sm" type="submit">
												Add Email
											</button> */}
											</div>
										</div>
									</form>
									<form
										className="form"
										onSubmit={(event) => this.handleUserSubmit(event)}
									>
										<button
											className="btn btn-primary account__btn account__btn--small"
											type="submit"
										>
											Add Recruiter
										</button>
									</form>
								</div>
							</Modal>
						</CardBody>
					</Card>
				</Col>
			</Container>
		);
	}
}

export default Dashboard;
